// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC5xzvEtBfM9CwDhyj7dbZYtpkgBhau4XY",
  authDomain: "luxe-cc8c3.firebaseapp.com",
  projectId: "luxe-cc8c3",
  storageBucket: "luxe-cc8c3.firebasestorage.app",
  messagingSenderId: "85587439053",
  appId: "1:85587439053:web:35f78c31ea049b1eba6884",
  measurementId: "G-Z12W7GB4DX"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
